import Vue from 'vue';
import App from './App';
import createStore from './store/store';
import { createRouter } from './router/router.js'
import { mapState } from 'vuex';

//sessions
Vue.config.productionTip = false;


//import { sync } from 'vuex-router-sync'
//=======================================
global.isBrowser = (typeof window !== 'undefined');
global.isServer = !isBrowser;
global.appContainer = {};
global.Components = {};
global.clickedElement = null;
global.jQuery = require('jquery');
if (isBrowser) {
    var $ = global.jQuery;
    window.$ = $;
}
//===================================================================================================
import mixin from './vue/mixin';
Vue.use(mixin);
import axios_interceptors from './vue/axios_interceptors';
Vue.use(axios_interceptors);
import directives from './vue/directives';
Vue.use(directives);
import filters from './vue/filters';
Vue.use(filters);
import constants from './vue/constants';
Vue.use(constants);
import VueJsonLD from 'vue-jsonld';
Vue.use(VueJsonLD);
import vue_utils from './vue/vue_utils';
Vue.use(vue_utils);

//=================Assets Loading========================================================
import './assets/css/bootstrap.css';
import './assets/css/main.css';
import('./assets/js/frontend.js');
import 'vue2-datepicker/index.css';
//------------------------
import './assets/css/app.css';
import('./assets/js/app.js');
import('./assets/js/mobile.js');
import('./assets/js/utils.js');
//====================Vue Meta Data=======================================================
import Meta from 'vue-meta';
import moment from 'moment';
import VueMoment from 'vue-moment';


Vue.use(VueMoment, { moment });
Vue.use(Meta, {
    ssrAppId: 1 // https://vue-meta.nuxtjs.org/guide/caveats.html#duplicated-tags-after-hydration-with-ssr
});
//====================Cookies=======================================================
import Cookies from 'js-cookie';
global.cookies = Cookies.withAttributes({
  path: '/',
  secure: true,
  sameSite: 'strict',
  expires: 9999999
})
//------------------Form Validation---------------------------------------------
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
//====================Multiselect=======================================================
//import Multiselect from 'vue-multiselect';
//Vue.component('multiselect', Multiselect);
//====================Uploader==========================================================
//import uploader from 'vue-image-crop-upload';
//Vue.component('my-upload', uploader);
//====================VModal============================================================
//import VModal from 'vue-js-modal';
////Vue.use(VModal);
//Vue.use(VModal, {dynamic: true, injectModalsContainer: true});
//=====================Phone Number DropDown============================================
//import 'vue-tel-input/dist/vue-tel-input.css';
//import VueTelInput from 'vue-tel-input';
//Vue.use(VueTelInput);
//======================Toaster=========================================================
import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
//=============================polyfill=================================================
import babelPolyfill from 'babel-polyfill'
import {polyfill}
from 'es6-promise';
if(isBrowser){
    if (!('Promise' in window)) {
        polyfill();
    }
}
import 'array-flat-polyfill';
//=======================Datepicker==================================================================
//import DatePicker from 'vue2-datepicker';
//import DatePicker from 'vuejs-datepicker';
//===================================================================================================
// import Echo from 'laravel-echo';
// if (isBrowser) {
//     window.io = require('socket.io-client');
// }
//===================================================================================================
Vue.config.productionTip = false;
//===================================================================================================
//

export function createApp(context) {

const store = createStore(context.state);
if (isBrowser) {
    store.commit('initialiseStore');
}

const router = createRouter();


//sync(store, router)

const app = new Vue({
//    i18n,
    store,
    router,
    render: h => h(App),
    data() {
        return {
        };
    },
    mounted() {
        var _this = this;
//         if (typeof io !== 'undefined') {
//             window.Echo = new Echo({
//                 broadcaster: 'socket.io',
// //                transports: ['websocket', 'polling'],
//                 host: process.env.SOCKET_URL,
//                 auth: {
// //                    headers: ''
//                 },
//             });
//             window.Echo.channel('PlanetCricket')
//                     .listen('MatchUpdated', (e) => {
//                         _this.$emit('MatchUpdated', e.data);
//                         console.log(e.data.match_id);
//                     });
//         }
    },
    beforeCreate() {

    },
//    computed: mapState(['user']),
});

global.$root = app;

    return {app, router, store};
}
